import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Col, Flex, Form, Input, message, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import SelectLayoutNew from "../../../components/select-layout/SelectLayoutNew";
import API from "../../../services/api-request";
import { useNavigate } from "react-router";

const ModalConfirmation = ({
  action,
  onCancel,
  closeParentModal,
  open,
  floor,
  pallet,
  getAreaData,
}) => {
  const [modal, showModal] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionForm] = Form.useForm();

  const handleOk = (value) => {
    if (!value) message.warning("Please select destination area");

    actionForm.setFieldValue("to", value.name);

    showModal(false);
  };

  const handleMoveArea = () => {
    if (!selectedArea || !floor) {
      message.info("Please select destination area");
      return;
    }

    setLoading(true);

    if (action.toLowerCase() === "move") {
      API.Post("area/move-area", {
        areaIdFrom: floor.id,
        areaIdTo: selectedArea.id,
      })
        .then((res) => {
          if (res.status === 201) {
            message.success(`Area ${action}d!`);
          }
        })
        .catch((err) => {
          console.log(err);
          message.error("Failed to move area!");
        })
        .finally(() => {
          setLoading(false);
          actionForm.resetFields();
          showModal(false);
          onCancel();
          closeParentModal();
          setSelectedArea({});
          getAreaData();
        });
    }
  };

  const handleMergePallet = () => {
    if (!selectedArea || !floor) {
      message.info("Please select destination area");
      return;
    }

    setLoading(true);

    if (action.toLowerCase() === "merge") {
      if (floor?.id === selectedArea.id) {
        message.error("Can't merge to the same area!");
        setLoading(false);
        return;
      }

      API.Post("area/merge-pallet", {
        palletIdFrom: pallet?.id,
        palletIdTo: selectedArea?.pallet_id,
      })
        .then((res) => {
          if (res.status === 201) {
            message.success(`Pallet ${action}d!`);
          }
        })
        .catch((err) => {
          console.log(err);
          message.error(
            `Failed to merge pallet: ${err.response.data.error ?? "unknown error"}`,
          );
        })
        .finally(() => {
          setLoading(false);
          actionForm.resetFields();
          showModal(false);
          onCancel();
          closeParentModal();
          setSelectedArea({});
          getAreaData();
        });
    }
  };

  useEffect(() => {
    actionForm.setFieldValue("from", floor.name);
  }, [floor]);

  return (
    <>
      <Modal
        centered
        title={
          <p style={{ textAlign: "center" }}>
            Are you sure you want to {action} this item?
          </p>
        }
        open={open}
        onCancel={() => {
          setSelectedArea(null);
          actionForm.setFieldValue("to", null);
          onCancel();
        }}
        footer={
          <Flex align="center" justify="center" gap={24}>
            <Button
              type="primary"
              style={{ width: "100%", backgroundColor: "#26d3a6" }}
              onClick={() => {
                action.toLowerCase() === "move"
                  ? handleMoveArea()
                  : handleMergePallet();
              }}
              loading={loading}
            >
              Confirm
            </Button>
            <Button
              type="primary"
              style={{ width: "100%", backgroundColor: "#d32526" }}
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </Button>
          </Flex>
        }
      >
        <Form layout="vertical" form={actionForm}>
          <Row>
            <Col span={11}>
              <Form.Item label="From" name="from">
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col
              span={2}
              style={{
                marginTop: "1.8rem",
                textAlign: "center",
                fontSize: "20px",
              }}
            >
              <ArrowRightOutlined />
            </Col>
            <Col span={11}>
              <Form.Item label="To" name="to" rules={[{ required: true }]}>
                <Input
                  placeholder="Pilih Area"
                  readOnly
                  onClick={() => {
                    showModal(true);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title="Silahkan Pilih Rak"
        okText="Ok"
        cancelText="Tutup"
        open={modal}
        onOk={handleOk}
        onCancel={() => {
          showModal(false);
          actionForm.setFieldValue("to", null);
        }}
        okType={"primary"}
        width="80%"
        height="80%"
        footer={null}
      >
        <SelectLayoutNew
          value={selectedArea?.id}
          onChange={(value) => {
            handleOk(value);

            setSelectedArea(value);
          }}
          action={action}
        />
      </Modal>
    </>
  );
};

export default ModalConfirmation;
